import { SignUp } from "../features/signup"
import MyPageLayout from "../layout/MyPage/MyPageLayout"
import type { NextPageWithLayout } from "../types/next"

const SignUpPage: NextPageWithLayout = () => {
  return <SignUp />
}

export default SignUpPage

SignUpPage.getLayout = (page) => {
  return <MyPageLayout layout="simple">{page}</MyPageLayout>
}
